var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalFollowers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 411.261,
    viewBox: "0 0 960 411.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "followersa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.491,247.075A134.584,134.584,0,0,0,653.51,365.2q1.807.985,3.643,1.917a131.527,131.527,0,0,0,13.978,6.132q2.852,1.074,5.763,2c.187.064.377.128.566.182a134.34,134.34,0,0,0,114.224-15.639q3.357-2.2,6.576-4.583c1.213-.9,2.41-1.821,3.589-2.767q5.008-3.974,9.614-8.423a134.6,134.6,0,1,0-227.973-96.946Z",
    transform: "translate(-583.491 -112.461)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-322.66 -380.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.555,4.714h0c-.042.041-.08.084-.127.127A16.683,16.683,0,0,0,5.064,4.711h0a16.684,16.684,0,0,0-.506,23.431h0l.156.161h0l23.1,23.783L51.75,28.835l-.067-.068c.041-.038.082-.073.127-.113h0a16.687,16.687,0,0,0,.346-23.594h0a16.687,16.687,0,0,0-23.6-.344h0Z",
    transform: "translate(1164.545 683.679) rotate(68)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.695,247.076A134.584,134.584,0,0,1,782.676,365.2q-1.807.985-3.643,1.917a131.559,131.559,0,0,1-13.978,6.132q-2.852,1.074-5.763,2c-.187.064-.377.128-.566.181A134.34,134.34,0,0,1,644.5,359.8q-3.357-2.2-6.576-4.583c-1.212-.9-2.41-1.821-3.589-2.767q-5.008-3.974-9.614-8.423a134.6,134.6,0,1,1,227.973-96.949Z",
    transform: "translate(72.469 280.488)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.795,75.938l1.488-26.366A27.409,27.409,0,0,1,27.406,0h0A27.339,27.339,0,0,1,54.811,27.27c0,.046,0,.091,0,.137A27.407,27.407,0,0,1,40.189,51.658V75.938Z",
    transform: "translate(764.881 448.258)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.9,414.195l-3.034,11.473,11.523,54.07a135.16,135.16,0,0,1-94.223-4.847l8.991-37.712.3-20.457.979-67.456.246-.128a.19.19,0,0,1,.048-.021l22.914-11.767,39.539-.988,29.5,14.368-.226.838Z",
    transform: "translate(1.81 176.186)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.586,624.509a9.656,9.656,0,0,1,2.578-14.58l-6.417-33.708,16.459,6.859,3.571,30.957a9.708,9.708,0,0,1-16.192,10.469Z",
    transform: "translate(-83.716 64.443)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.963,
    height: 42.095,
    rx: 4,
    transform: "translate(763.312 611.658) rotate(7)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.66,
    cy: 3.66,
    rx: 3.66,
    ry: 3.66,
    transform: "translate(769.91 618) rotate(7)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.439,364.026l4.223-1.374s13.4,8.6,12.125,29.384c0,0,.5,10.756.023,17.915-.55,8.209,6.82,89.8,6.82,89.8H905.755l-10.23-73.889Z",
    transform: "translate(-72.897 163.938)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.968,555.548a9.656,9.656,0,0,0-12.433-8.039l-20.318-27.651-6.182,16.725,20.242,23.693a9.708,9.708,0,0,0,18.692-4.728Z",
    transform: "translate(5.596 90.701)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.655,361.085l-3.681-2.485s-21.9,2.039-26.406,22.368c0,0-3.294,12.216-4.807,19.229-.778,3.607-11.155,38.458-11.155,38.458L714.8,477.113l9.615-14.42L714.8,438.658Z",
    transform: "translate(27.691 165.826)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.66 383.903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.841,3.521A9.656,9.656,0,0,0,6.417,18.1L0,51.808l16.459-6.859,3.574-30.957A9.708,9.708,0,0,0,3.841,3.521Z",
    transform: "translate(112.41 357.279) rotate(166)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.491,247.075A134.584,134.584,0,0,0,653.51,365.2q1.807.985,3.643,1.917a131.527,131.527,0,0,0,13.978,6.132q2.852,1.074,5.763,2c.187.064.377.128.566.182a134.34,134.34,0,0,0,114.224-15.639q3.357-2.2,6.576-4.583c1.213-.9,2.41-1.821,3.589-2.767q5.008-3.974,9.614-8.423a134.6,134.6,0,1,0-227.973-96.946Z",
    transform: "translate(-583.491 -112.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#followersa)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.482 88.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.738,44.523a25.9,25.9,0,1,1,29.6,4.557c-.9,4.926-2.822,16.8-.8,18.706C41.1,70.2,0,74.675,0,74.675S7.2,55.621,9.738,44.523Z",
    transform: "translate(35.868)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.214,283.5s-4.4,22.97.979,35.68c1.6,3.788,4.032,4.839,6.843,4.5V305.986s-3.422-66.962-15.641-74.786h-7.067a5.273,5.273,0,0,0-4.229,2.122Z",
    transform: "translate(-1053.099 -155.401)",
    opacity: 0.073
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.039,200.545c6.4,1.37,28.942,6.031,37.581,5.555a3.254,3.254,0,0,1,1.547.291l5.591,2.58,25.545,12.1a3.234,3.234,0,0,1,1.778,3.6l-9.193,42.9a3.229,3.229,0,0,0,1.7,3.56c7.47,3.772,23.44,43.764-6.35,53.279-35.192,11.242-50.864,11.448-58.2,9.493s-8.068-13.493-13.444-26.2c-4.761-11.253-1.857-30.555-1.13-34.827a3.221,3.221,0,0,0-.166-1.689l-18.2-47.773a3.234,3.234,0,0,1,1.552-4.032l20.908-10.667a3.238,3.238,0,0,0,.817-.594l6.7-6.7a3.231,3.231,0,0,1,2.958-.873Z",
    transform: "translate(-917.547 -143.924)",
    fill: "#d0cde1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1053.327,265.9c1.958,20.529,4.888,129.037,13.2,132.458s21.991,3.421,21.991,3.421v-95.8s-3.421-66.962-15.641-74.786h-7.068a5.272,5.272,0,0,0-4.229,2.122c-.063.082-.122.17-.18.258A51.214,51.214,0,0,0,1053.327,265.9Z",
    transform: "translate(-985.842 -67.1)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.26 166.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.586,624.509a9.656,9.656,0,0,1,2.578-14.58l-6.417-33.708,16.459,6.859,3.571,30.957a9.708,9.708,0,0,1-16.192,10.469Z",
    transform: "translate(-893.672 -463.056)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.358,234.322h3.9a2.96,2.96,0,0,1,2.908,2.41l12.739,67,17.4,61.586s-31.573,9.287-29.13,0-21.017-69.895-21.017-69.895Z",
    transform: "translate(-856.16 -234.322)",
    fill: "#d0cde1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.793,7.608c5.8,2.038,9.117,3.208,12.156,6.132,5.132,4.946,5.981,11.555,6.768,17.7.616,4.8,1.413,11.017-1.4,18.113-.962,2.422-5.618,13.213-14.532,14.574-1.751.268-5.861.338-4.676-.537,10.964-8.094,15.643-12.981,15.26-25.455-.241-7.752-12.083-16.118-19.116-17.625a11.978,11.978,0,0,0-9.732,2.266c-5.911,4.852-5.659,24.92-11.892,29.114-2.566,1.726-.856-10.418-2.662-8.45-3.563,3.885-1.278,9.832-.637,12.1,3.038,10.752,6.217,2.8,9.184,11.98,3.2,9.91-24.893,16.582-25.848,18.8C217,90.163,240.757,108.428,234.236,111.6c-8.277,4.022-14.8-1.216-18.65,3.277-2.152,2.51-.987,5.168-4.873,12.977-1.269,2.549-1.906,3.823-2.464,3.778-2.657-.213-6.958-21.477,0-41.285,2.92-8.312,5.78-16.457,13.443-22.823,4.054-3.368,7.453-4.578,8.42-8.507,1.382-5.618-4.358-8.014-5.509-16.874-.787-6.06-1.339-14.728.8-20.288,2.022-5.247,3.775-9.8,8.368-13.93,1.107-.994,10-7.737,19.446-7.926,4.345-.087,7.538,5.837,12.576,7.608h0Z",
    transform: "translate(212.367 458.615)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.989,2.8h0c-.025.024-.047.05-.075.075A9.925,9.925,0,0,0,3.013,2.8h0a9.926,9.926,0,0,0-.3,13.94h0l.093.1h0l13.742,14.15L30.788,17.155l-.04-.041c.024-.023.049-.044.075-.067h0a9.928,9.928,0,0,0,.206-14.037h0a9.928,9.928,0,0,0-14.038-.2h0Z",
    transform: "translate(563.677 447.529) rotate(15.009)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.989,2.8h0c-.025.024-.047.05-.075.075A9.925,9.925,0,0,0,3.013,2.8h0a9.926,9.926,0,0,0-.3,13.94h0l.093.1h0l13.742,14.15L30.788,17.155l-.04-.041c.024-.023.049-.044.075-.067h0a9.928,9.928,0,0,0,.206-14.037h0a9.928,9.928,0,0,0-14.038-.2h0Z",
    transform: "translate(513.273 417.109) rotate(-11)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.989,2.8h0c-.025.024-.047.05-.075.075A9.925,9.925,0,0,0,3.013,2.8h0a9.926,9.926,0,0,0-.3,13.94h0l.093.1h0l13.742,14.15L30.788,17.155l-.04-.041c.024-.023.049-.044.075-.067h0a9.928,9.928,0,0,0,.206-14.037h0a9.928,9.928,0,0,0-14.038-.2h0Z",
    transform: "translate(568.265 380.558) rotate(3)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.983 675.874) rotate(14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.647,
    height: 95.647,
    rx: 8,
    transform: "translate(0 0)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.159 34.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.151,9.393a1.873,1.873,0,0,1-1.328-.55L7.515,4.535,3.207,8.843A1.879,1.879,0,0,1,.55,6.186L6.186.55a1.879,1.879,0,0,1,2.657,0l5.636,5.636a1.879,1.879,0,0,1-1.328,3.207Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.908,26.3H5.636A5.642,5.642,0,0,1,0,20.665V1.879a1.879,1.879,0,0,1,3.757,0V20.665a1.881,1.881,0,0,0,1.879,1.879H16.908a1.879,1.879,0,0,1,0,3.757Z",
    transform: "translate(5.636 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.515,9.393a1.873,1.873,0,0,1-1.328-.55L.55,3.207A1.879,1.879,0,0,1,3.207.55L7.515,4.858,11.822.55a1.879,1.879,0,1,1,2.657,2.657L8.843,8.843A1.873,1.873,0,0,1,7.515,9.393Z",
    transform: "translate(26.301 16.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.908,26.3a1.879,1.879,0,0,1-1.879-1.879V5.636a1.881,1.881,0,0,0-1.879-1.879H1.879A1.879,1.879,0,0,1,1.879,0H13.151a5.642,5.642,0,0,1,5.636,5.636V24.423A1.879,1.879,0,0,1,16.908,26.3Z",
    transform: "translate(16.908 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 791.409, 675.874)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.25,
    height: 60.25,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.704 17.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.735,0h.014a4.782,4.782,0,0,1,4.583,5.927l-.809,3.335H21.8a3.473,3.473,0,0,1,3.334,4.446l-2.7,9.262a3.491,3.491,0,0,1-3.334,2.5H3.473A3.477,3.477,0,0,1,0,22V12.735A3.477,3.477,0,0,1,3.473,9.262h3.2A1.151,1.151,0,0,0,7.7,8.619l4-7.98A1.158,1.158,0,0,1,12.735,0ZM19.1,23.155a1.164,1.164,0,0,0,1.111-.834l2.7-9.262A1.158,1.158,0,0,0,21.8,11.578h-6.75a1.158,1.158,0,0,1-1.125-1.431l1.158-4.77A2.468,2.468,0,0,0,13.4,2.418L9.776,9.653a3.452,3.452,0,0,1-3.107,1.924h-3.2a1.159,1.159,0,0,0-1.158,1.158V22a1.159,1.159,0,0,0,1.158,1.158Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.158,16.209A1.158,1.158,0,0,1,0,15.051V1.158a1.158,1.158,0,1,1,2.316,0V15.051A1.158,1.158,0,0,1,1.158,16.209Z",
    transform: "translate(5.789 9.262)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(866.419 413.276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.491,0A17.491,17.491,0,1,1,0,17.491,17.491,17.491,0,0,1,17.491,0Z",
    transform: "translate(0 0)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.059,13.077h-.02a2.039,2.039,0,0,1,0-4.077h.02a2.039,2.039,0,0,1,0,4.077Z",
    transform: "translate(1.327 2.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.059,13.077h-.02a2.039,2.039,0,0,1,0-4.077h.02a2.039,2.039,0,0,1,0,4.077Z",
    transform: "translate(7.558 2.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.542,19.367A9.891,9.891,0,0,1,9.12,17.1,1.759,1.759,0,0,1,11.4,14.419a6.462,6.462,0,0,0,4.143,1.43,6.462,6.462,0,0,0,4.143-1.43A1.759,1.759,0,0,1,21.964,17.1,9.891,9.891,0,0,1,15.542,19.367Z",
    transform: "translate(1.859 7.113)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M583.491,247.075A134.584,134.584,0,0,0,653.51,365.2q1.807.985,3.643,1.917a131.527,131.527,0,0,0,13.978,6.132q2.852,1.074,5.763,2c.187.064.377.128.566.182a134.34,134.34,0,0,0,114.224-15.639q3.357-2.2,6.576-4.583c1.213-.9,2.41-1.821,3.589-2.767q5.008-3.974,9.614-8.423a134.6,134.6,0,1,0-227.973-96.946Z",
    transform: "translate(405.689 271.442)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(989.18 383.903)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.193 61.692)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.799 65.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.924,293.951c9.382-1.215,16.36-7.042,15.585-13.012s-9.007-9.824-18.392-8.607a23.675,23.675,0,0,0-10.491,3.872l-39.687,5.651,3.049,18.568,38.8-7.543a23.677,23.677,0,0,0,11.134,1.072Z",
    transform: "translate(-162.514 -194.131)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.037,214.12l10.885,81.037s2.994,17.428,30.25,14.863,63.075-13.137,63.075-13.137l-2.331-18.923-30.443,3.3s-14.213-3.448-17.033-1.122-1.523,5.047-4.315,1.662-1.389-5.487-3.832-2.527-2.939,8.107-4.4,1.733-4.185-5.076-4.185-5.076l-1.549-59.365s-8.178-28.317-23.114-18.849-13.009,16.407-13.009,16.407Z",
    transform: "translate(-163.956 -195.776)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.814,205.126l1.888-22.817h25.1l5.565,24.174Z",
    transform: "translate(-142.031 -130.645)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.759,400.68c2.364,9.161,9.006,15.366,14.833,13.861s8.638-10.152,6.272-19.314a23.675,23.675,0,0,0-5.137-9.933l-10.505-38.687-18.048,5.317L194.446,389.5a23.678,23.678,0,0,0,.311,11.181Z",
    transform: "translate(-141.764 -127.105)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.084,237.567s-10.223-27.627-21.428-25.832-21.42,19.165-21.42,19.165l8.1,98.283,22.248,56.084,23.6-9.306-12.26-56.05Z",
    transform: "translate(-142.302 -130.01)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.654,172.187c-3.074,13.39-22.1,4.91-22.1,4.91l-8.686-44.245,20.993-9.315S94.73,158.8,91.654,172.187Z",
    transform: "translate(-12.32 -107.814)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.114,
    cy: 26.114,
    r: 26.114,
    transform: "translate(21.169 6.881)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.507,258.068s12.272,4.09,12.9,20.242a28.655,28.655,0,0,1-.852,7.671c-.691,2.928,5.292,29.46-2.272,13.762a111.248,111.248,0,0,0-8.833-31.363l-.1-.208s-5.9,10.957-17.689,10.957l4.211-4.211S245.34,282.5,238.6,282.5c0,0-5.055,3.369,0,8.424s15.163,16.847,9.262,26.114-.842,11.793-.842,11.793l-9.262-5.055-4.211-2.527v3.369l-21.9-2.527s-5.9-.842,6.739-15.163c0,0,3.337-5.561,1.877-10.357a24.192,24.192,0,0,1-.919-11.315C222.172,269.463,233.278,238.068,276.507,258.068Z",
    transform: "translate(-210.27 -251.609)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.934, -0.358, 0.358, -0.934, 162.183, 173.921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.469,50.2A2.324,2.324,0,0,1,.2,47.814l.2-7.981L0,39.8l.144-5.421.39.049.71-28.59A4.032,4.032,0,0,1,4.85,1.93L23.031.017A3.051,3.051,0,0,1,26.4,3.258L23.638,43.967a3.775,3.775,0,0,1-3.183,3.473L2.9,50.166h0a2.324,2.324,0,0,1-.434.03Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.656,43.793,5.43,45.226a.764.764,0,0,0-.642.672h0a.866.866,0,0,1-.726.761l-1.943.3A1.834,1.834,0,0,1,0,45.1L1,3.657A2.094,2.094,0,0,1,2.909,1.622L21.074.006a1.617,1.617,0,0,1,1.757,1.708L20.379,42.047a2.609,2.609,0,0,1-2.2,2.417l-2.045.318a1.3,1.3,0,0,0-1.475-.989Z",
    transform: "translate(1.882 2.166)",
    fill: "#7C3AED"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    clipPath: "url(#followersa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.836,204.8l-32.963-9.316s-15.356,10.9-17.55,38.5,8.776,71.9,8.776,71.9l-8.775,27.788s74.178,8.1,72.718,4.856-7.95-31.378-5.756-37.417-1.871-35.935-1.871-35.935,8.028-17.78-1.477-27.285Z",
    transform: "translate(-71.168 -68.668)",
    fill: "#090814"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1244.491 533.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.462,39.17A3.473,3.473,0,0,1,1.072,35a1.737,1.737,0,0,1,.049-.185L2.938,29.2a1.727,1.727,0,0,0-.077-.9,19.084,19.084,0,1,1,9.218,9.105,1.733,1.733,0,0,0-.842-.073L5.4,39.041l-.042.012A3.5,3.5,0,0,1,4.462,39.17Zm7.051-5.328a5.2,5.2,0,0,1,1.847.339q.06.023.118.05a15.614,15.614,0,1,0-7.466-7.384q.018.036.034.074h0c.011.025.021.05.031.076a5.186,5.186,0,0,1,.237,3.016q-.018.082-.044.161L4.483,35.695l5.867-1.716q.074-.022.149-.037A5.209,5.209,0,0,1,11.513,33.843Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.752,14.47H8.735a1.735,1.735,0,1,1,0-3.47h.017a1.735,1.735,0,1,1,0,3.47Z",
    transform: "translate(3.41 6.348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.752,14.47h-.017a1.735,1.735,0,0,1,0-3.47h.017a1.735,1.735,0,1,1,0,3.47Z",
    transform: "translate(6.35 6.348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.752,14.47h-.017a1.735,1.735,0,0,1,0-3.47h.017a1.735,1.735,0,0,1,0,3.47Z",
    transform: "translate(9.289 6.348)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.2,300.237c-3.245-9-16.646-1.989-29.1.419s-11.9,26.181-11.9,26.181-7.645-12.624-7.645-26.757,6.718-10.783,7.66-12.876,3.455-.628,3.455-.628,1.361-5.234,5.13-4.5a5.342,5.342,0,0,0,5.549-2.094c18.216-9.736,15.389-.733,22.3.523s5.863,2.931,8.061,6.909a75.647,75.647,0,0,1,4.4,11.1,25.7,25.7,0,0,0,.733,7.642c1.047,4.4-1.675,8.48-1.675,8.48a68.631,68.631,0,0,1-6.962-14.395Z",
    transform: "translate(433.616 165.706)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalFollowers);
export default __webpack_public_path__ + "static/media/goal-followers.75ac186a05e1ac326bfef176377864fb.svg";
export { ForwardRef as ReactComponent };